import { render, staticRenderFns } from "./MallReturnOrderDetail.vue?vue&type=template&id=bcf1b2f8&scoped=true"
import script from "./MallReturnOrderDetail.vue?vue&type=script&lang=ts"
export * from "./MallReturnOrderDetail.vue?vue&type=script&lang=ts"
import style0 from "./MallReturnOrderDetail.vue?vue&type=style&index=0&id=bcf1b2f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf1b2f8",
  null
  
)

export default component.exports